export { default } from "./CheckConfigDialog";
